import { useCallback } from "react";
import { CommandStatus, useCommand } from "@lookiero/messaging-react";
import { Logger } from "@lookiero/sty-psp-logging";
import { playGame } from "../../../../domain/game/command/playGame";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";

interface PlayGameFunctionArgs {
  readonly id: string;
  readonly like: boolean;
}
interface PlayGameFunction {
  (args: PlayGameFunctionArgs): Promise<void> | undefined;
}

interface UsePlayGameArgs {
  readonly view: string;
  readonly logger: Logger;
}

type UsePlayGameResult = [play: PlayGameFunction, status: CommandStatus];

interface UsePlayGame {
  (args: UsePlayGameArgs): UsePlayGameResult;
}

const usePlayGame: UsePlayGame = ({ view, logger }) => {
  const [commandBus, status] = useCommand({ contextId: MESSAGING_CONTEXT_ID });

  const play: PlayGameFunction = useCallback(
    async ({ id, like }) => {
      try {
        await commandBus(playGame({ aggregateId: id, like, view }));
      } catch (error) {
        logger.captureException(error as Error);
      }
    },
    [commandBus, logger, view],
  );

  return [play, status];
};

export { usePlayGame };
